import useScreenSize from "../hooks/useScreenSize";

const products: IProduct[] = [
	{
		name: "Slush",
		imgUrl: "https://s3.kftus.com/kft-cms/taro_slush_570a103958.webp",
		imgUrl_desktop:
			"https://s3.kftus.com/kft-cms/taro_slush_ccc97f8d91.webp",
		description: `Embark on a new adventure with Gallica in Metaphor: ReFantazio! Just like our spirited fairy companion, this Taro Slush is sweet with a hint of nuttiness, offering a delightful blend of flavor and sass.`
	},
	{
		name: "Mango Milk Tea",
		imgUrl: "https://s3.kftus.com/kft-cms/Mango_milk_tea_cab50c644f.webp",
		imgUrl_desktop:
			"https://s3.kftus.com/kft-cms/Mango_milk_tea_05f774131e.webp",
		description: `Strohl's noble sense of justice in Metaphor: ReFantazio is perfectly reflected in the earthy sweetness of Oolong tea, complemented by the subtle tartness of Mango milk tea. A blend as balanced and righteous as his character.`
	},
	{
		name: "Lemon Green Tea",
		imgUrl: "https://s3.kftus.com/kft-cms/Strawberry_Lemon_Green_Tea_de513fbadd.webp",
		imgUrl_desktop:
			"https://s3.kftus.com/kft-cms/Strawberry_Lemon_Green_Tea_acbe000ee3.webp",
		description: `Hulkenberg's relentless drive in Metaphor: ReFantazio is captured in this invigorating lemonade. With the sweetness of strawberries and the eccentric touch of jasmine green tea, this blend is as bold and refreshing as her spirit.`
	},
	{
		name: "Almond Milk Tea",
		imgUrl: "https://s3.kftus.com/kft-cms/Almond_Milk_Tea_png_64f1211809.webp",
		imgUrl_desktop:
			"https://s3.kftus.com/kft-cms/Almond_Milk_Tea_091c0fe9a5.webp",
		description: `Experience the richness of Heismay’s story in Metaphor: ReFantazio with the smooth, balanced flavors of Earl Grey tea and sweet almond, perfectly capturing his gentle spirit.`
	}
];

export default function Products() {
	const screenSizes = useScreenSize();

	return (
		<div id="siteProducts">
			{products.map((product, index) => {
				let imgUrl = product.imgUrl;
				if (screenSizes.isLarge) {
					imgUrl = product.imgUrl_desktop;
				}

				const even = (index + 1) % 2 === 0;

				return (
					<div
						key={index}
						className={"productItem " + (even ? "even" : "odd")}
					>
						<img
							src={imgUrl}
							alt={product.name}
							style={{
								width: "100%"
							}}
						/>

						<div className="productDescriptionWrapper">
							<p className="productDescription">
								{product.description}
							</p>
						</div>
					</div>
				);
			})}
		</div>
	);
}

interface IProduct {
	name: string;
	imgUrl: string;
	imgUrl_desktop: string;
	description: string;
}
